import type { ITerminalInitOnlyOptions, ITerminalOptions, ITheme } from "@xterm/xterm";

//From legacy systemLog.ejs, based on the ANSI-UP colors
//TODO: at component instantiation, grab those as variables from the CSS
// putting css variables here will not work (i think)
const baseTheme: ITheme = {
    background: '#030507',
    foreground: '#cbd5e1',
    black: '#0d1117',
    brightBlack: '#334155',
    red: '#f87171',
    brightRed: '#ef4444',
    green: '#00ff66',
    brightGreen: '#4ade80',
    yellow: '#fbbf24',
    brightYellow: '#fde68a',
    blue: '#60a5fa',
    brightBlue: '#93c5fd',
    magenta: '#c084fc',
    brightMagenta: '#e879f9',
    cyan: '#00ffd1',
    brightCyan: '#67e8f9',
    white: '#e2e8f0',
    brightWhite: '#f8fafc',
    cursor: '#00ffd1',
    selectionBackground: 'rgba(0,255,209,0.15)',
    selectionForeground: '#f8fafc',
};

const terminalOptions: ITerminalOptions | ITerminalInitOnlyOptions = {
    theme: baseTheme,
    convertEol: true,
    cursorBlink: true,
    cursorStyle: 'bar',
    disableStdin: true,
    drawBoldTextInBrightColors: false,
    fontFamily: "JetBrains Mono Variable, monospace",
    fontSize: 14,
    lineHeight: 1.1,
    fontWeight: "300",
    fontWeightBold: "600",
    letterSpacing: 0.8,
    scrollback: 5000,
    // scrollback: 2500, //more or less equivalent to the legacy 250kb limit
    allowProposedApi: true,
    allowTransparency: true,
    overviewRulerWidth: 15,
};

/*
    NOTE: When implementing a stored options dropdown, add the following options:
    - fontSize
    - lineHeight
    - scrollback
    - RTL fixes
    - light mode?
    - whether clicking on a saved command copies it to the input or executes it directly
*/
export default terminalOptions;
